import {
  systemImpersonationControllerImpersonateUser,
  systemImpersonationControllerStopImpersonation,
} from "../../api/generated";

// SYSTEM_ADMIN company impersonation. The super-admin mints a short-lived token that acts AS a
// company ADMIN/TRAINER; every /admin/* call is then scoped through that (impersonated) principal.
// Backed by SystemImpersonationController (/system/impersonate/*).
//
// Migrated to the OpenAPI-generated client. impersonateUser returns HttpResponse<String>, so
// `data` == the old axios `response.data` (the {statusCode,errorMessage,body} envelope) and the
// caller keeps reading `res.data.body` for the token.

// Start impersonating a specific user (an ADMIN or TRAINER of some company). Returns the short-lived
// impersonation token (HttpResponse<String>.body). configureApi's interceptor supplies the
// super-admin's own token here (impersonation hasn't started yet), so no override is needed.
export const impersonateUser = async (userId) => {
  const {data, error} = await systemImpersonationControllerImpersonateUser({path: {userId}});
  if (error) throw error;
  return {data};
};

// Explicit, auditable exit. The server has nothing to revoke (impersonation lives in the token) —
// this just records the exit; the client restores the super-admin's own login token.
//
// IMPORTANT: this must be called with the SUPER-ADMIN's own token (passed in), NOT the active
// impersonation token — /system/impersonate/** is SYSTEM_ADMIN-only, and the impersonation token
// carries only the company user's roles, so using it would 401/403. At this point
// localStorage('auth') is STILL the impersonation token, so we override the Authorization header
// per-call; configureApi's interceptor only sets it when absent, so this explicit header wins.
export const stopImpersonation = async (superAdminToken) => {
  const {data, error} = await systemImpersonationControllerStopImpersonation({
    headers: {Authorization: `Bearer ${superAdminToken}`},
  });
  if (error) throw error;
  return {data};
};
